<template lang="html">
  <vs-card class="cardx">
    <div slot="header" style="padding:10px">
      <h3>
        Coupons
      </h3>
    </div>
  <div>
    <vs-table stripe
              search
              :sst="true"
              @search="handleSearch"
              :data="coupons.coupons">
      <template slot="thead">
        <vs-th sort-key="code">
          Code
        </vs-th>
        <vs-th sort-key="type">
          Type
        </vs-th>
        <vs-th sort-key="since">
          Since
        </vs-th>
				<vs-th sort-key="until">
         Until
        </vs-th>
        <vs-th>
          Status
        </vs-th>
				<vs-th>
          Action
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="coupon.driver_id" v-for="coupon in data">
          <vs-td>
            {{coupon.code}}
          </vs-td>
          <vs-td>
            {{coupon.type}}
          </vs-td>
          <vs-td>
            {{coupon.since}}
          </vs-td>
          <vs-td>
            {{coupon.until}}
          </vs-td>
          <vs-td>
            <vs-chip transparent :color="coupon.is_active ?'success':'warning'">
              {{coupon.is_active ? 'Active':'Inactive'}}
            </vs-chip>
          </vs-td>
          <vs-td>
            <feather-icon v-if="false" @click="editCoupon(coupon.id)" icon="EditIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
            <feather-icon @click="openConfirm(coupon.id)" icon="Trash2Icon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="mt-3 mb-3">

       <span style="float:left;">
                  <vs-select
                    @input="filters.page=1"
                    class=""
                    label=""
                    v-model="filters.limit"
                    width="100px"
                    size="small"

                  >
                    <vs-select-item :key="'lim-'+index" :value="item.value" :text="item.text" v-for="(item,index) in limitOptions" />
                  </vs-select>
                </span>
      <pagination :last-page="coupons.pagination.pages" v-model="filters.page" />
    </div>
  </div>
  </vs-card>
</template>


<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker';
import limitOptions from "../../constants/limit";

export default {
  components:{
    Datepicker
  },
	data (){
		return {
		  form : {
		    name: null,
        coupon_code : null,
        coupon_value: null,
        discount_type : 'trip',
        schedule : {
		      from : null,
          to: null
        }
      },
      page:0,
      displayForm : false,
      filters: {},
      limitOptions
		}
	},
	computed : {
    ...mapGetters('users',['userCan']),
		...mapState('coupons',['coupons','currentPage']),
    validForm(){
		  return !!this.form.name && !!this.form.coupon_code && !!this.form.discount_type
        && !!this.form.coupon_value && !!this.form.schedule.from && !!this.form.schedule.to
    },
	},
	created () {
    this.filters = {
      limit: '20',
      ...this.$route.query,
      page: this.$route.query.page ? Number(this.$route.query.page) : 1,
    };
    this.doSearch = _.debounce(this.getItems,300);
	},
  watch : {
    filters : {
      deep: true,
      handler(newVal, oldVal){
        this.setRouteQuery();
        //if(!_.isEqual(newVal, oldVal))
        this.doSearch();
      }
    }
  },
	methods: {
		...mapActions('coupons',['fetchCoupons','storeCoupon','deleteCoupon']),
    setRouteQuery(){
      let query = {...this.filters, page: `${this.filters.page}`};
      if(!_.isEqual(query, this.$route.query)){
        try{
          this.$router.push({query});
        }catch(error){

        }
      }
    },
    getItems(search){
      if(!this.userCan('coupons.read')){
        this.$vs.notify({
          color: 'danger',
          title: `Error`,
          text: 'You need permission to perform this action',
        });
        return;
      }

      this.$vs.loading({type:'point'});
      this.fetchCoupons(_.cloneDeep(this.filters))
      .then(data=>{
        this.$vs.loading.close();
      })
      .catch(error =>{
        this.$vs.loading.close();
      });
    },
    handleSearch(searching){
      this.filters = {...this.filters, page: 1, search: searching};
    },
    openConfirm(id){
      if(!this.userCan('coupons.delete')){
        this.$vs.notify({
          color: 'danger',
          title: `Error`,
          text: 'You need permission to perform this action',
        });
        return;
      }

      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirm`,
        text: "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept:()=>{
          this.deleteCoupon({id})
          .then(data=>{
            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Deleted successfully'
            });
            this.getItems();
          })
          .catch(error=>{
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Something went wrong'
            })
          });
        }
      })
    },
    editCoupon(id){
		  this.$router.push({name: 'coupons.edit',params : {id}})
    }
	}

}
</script>
